import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import {hasPermission} from "../../sc-utilities";
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }

});

export const systemTypes = [{value: "system", displayValue: "System chassis type"}, {value: "custom", displayValue: "Customer chassis type"}];

const ChassisTypeForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, types, permissions, CustomerIDPreviousState, fromEdit } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="TypeKey"
                                value={values.TypeKey}
                                onChange={(e) => {handleChange(e); setFieldValue('Key', e.target.value)}}
                                onBlur={handleBlur}
                                error={!!(errors.TypeKey && touched.TypeKey)}
                                placeholder={translations['chassis_type_key'] || 'Chassis type key'}
                                label={translations['chassis_type_key'] || 'Chassis type key'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={'dense'}>
                                <InputLabel shrink>{translations['chassis_type_value_text'] || "Please select chassis type value"}</InputLabel>
                                <Select name="TypeValue" margin={'dense'} value={values.TypeValue} onChange={handleChange}>
                                    {(types ? [...types] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {hasPermission(permissions, 'system_chassis_type_create') ? (<><FormControl className={classes.formControl}
                                                                                                           margin={"dense"}>
                                    <InputLabel
                                        shrink>{translations['chassis_type_system'] || "Please select system chassis type"}</InputLabel>
                                    <Select
                                        name="CustomerID"
                                        label={translations['chassis_type_system'] || 'Please select system chassis type'}
                                        margin={"dense"}
                                        value={values?.CustomerID?.toString() || ''}
                                        onChange={handleChange}
                                        disabled={values?.CustomerID?.toString() === 'system' && fromEdit && CustomerIDPreviousState==='system'}
                                    >
                                        {(systemTypes ? [...systemTypes] : []).map(option => (
                                            <MenuItem key={option.value} value={option.value.toString()}>
                                                {option.displayValue}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {values?.CustomerID?.toString() === 'system'  ? <TextField
                                    name="Key"
                                    value={values?.Key ? updateKey(values?.Key) : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Key)}
                                    placeholder={translations['chassis_type_system_key'] || 'Translate key'}
                                    label={translations['chassis_type_system_key'] || 'Translate key'}
                                    margin={"dense"}
                                    fullWidth={true}
                                /> : null}
                            </>) : null}
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24}/> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(ChassisTypeForm);
